import React from 'react';
import dateformat from 'dateformat';

import * as S from './HeaderNameChange.styles';

import IconSelector from '@ibibo/icon-selector';

const HeaderNameChange = ({tripDetails}) => {

  const isDateValid = (d) => {
    return (d instanceof Date && !isNaN(d));
  }

  const checkinDate = tripDetails.travel_start_datetime ? new Date(tripDetails.travel_start_datetime) : '';
  const checkOutDate = tripDetails.travel_end_datetime ? new Date(tripDetails.travel_end_datetime) : '';

  return(
    <S.HeaderCanelMainWrap>
      <S.HeaderCancelOuterWrap>
        <S.HeaderCancelImgWrap>
          <IconSelector iconKey='modifyheader'/>
        </S.HeaderCancelImgWrap>
        <S.HeaderCancelInfoWrap>
          <S.HeaderCancelText>Modify Booking</S.HeaderCancelText>
          <S.HeaderCancelInfoInnerWrap>
            <S.HeaderCancelHtlInfo>{tripDetails.hotel_name}</S.HeaderCancelHtlInfo>
            <S.HeaderCancelHtlDateInfoWrap>
              <S.HeaderCacnelHtlDateImg>
                <IconSelector iconKey='calendergrey'/>
              </S.HeaderCacnelHtlDateImg>
              {/* <S.HeaderCancelDateText>{dateformat(checkin, 'dd mmm')} - {dateformat(checkout, 'dd mmm')}</S.HeaderCancelDateText> */}
              <S.HeaderCancelDateText>{isDateValid(checkinDate) ? dateformat(checkinDate, 'dd mmm') : ''} - {isDateValid(checkOutDate) ? dateformat(checkOutDate, 'dd mmm') : ''}</S.HeaderCancelDateText>
            </S.HeaderCancelHtlDateInfoWrap>
          </S.HeaderCancelInfoInnerWrap>
        </S.HeaderCancelInfoWrap>
      </S.HeaderCancelOuterWrap>
    </S.HeaderCanelMainWrap>
  );
}

export default HeaderNameChange;
